import React, { Component } from 'react';

import { Button, Card, CardText, CardTitle, Grid, TextField } from 'react-md';

import Api from '../../common/api';
import Message from '../../components/message';
import { openSnackbar } from '../../components/message';
import { decodeJwtObject } from '../../common/base64'
import Breadcrumb from '../../components/Breadcrumb';
import { clearDigitsSpecialChars } from '../../common/parsers';
import { formatCpf } from '../../common/formaters';

export default class Profile extends Component {

    constructor(props) {
        super(props);

        this.state = {
            user: {
                id: "",
                id_pessoa: "",
                nome: "",
                email: "",
                cpf: "",
                senha: ""
            }
        };
    }

    componentDidMount() {
        const accessToken = localStorage.getItem("accessToken");
        const userToken = accessToken ? decodeJwtObject(accessToken).usuario : null;
        const user = {
            id: userToken.id || "",
            id_pessoa: userToken.id_pessoa || "",
            id_cliente: userToken.id_cliente || "",
            nome: userToken.nome || "",
            email: userToken.email || "",
            cpf: userToken.cpf || "",
            senha: userToken.senha || "",
        }
        this.setState({user});
    }

    render() {
        
        const { user } = this.state;
        
        return (
            <Grid>
                <Breadcrumb title="Perfil" url="/perfil"/>
                <Card className="md-cell md-cell--12 tw-card">
                    <CardTitle title="Meus Dados"/>
                    <CardText>
                        <form onSubmit={this.handleSubmit}>
                            <div className="md-grid">
                                <TextField id="nome" label="Nome" type="text" placeholder="Digite seu Nome" value={user.nome}
                                    className="md-cell md-cell--12" onChange={this.handleChange('nome')} required/>

                                <TextField id="email" label="Email" type="text" placeholder="Digite seu Email" value={user.email}
                                    className="md-cell md-cell--12" onChange={this.handleChange('email')} />
                                
                                <TextField id="cpf" label="CPF" type="text" placeholder="Digite seu CPF" value={user.cpf}
                                    className="md-cell md-cell--12" onChange={this.handleChangeCpf} required/>

                                <TextField id="senha" label="Senha" type="password" placeholder="Digite sua Senha" value={user.senha}
                                    className="md-cell md-cell--12" onChange={this.handleChange('senha')} />
                                
                                <div className="buttons__group">
                                    <Button type="submit" raised primary >Salvar</Button>
                                </div>
                            </div>
                        </form>
                    </CardText>
                </Card>
                <Message />
            </Grid>
        );
    }

    handleChange = name => value => {
        const user = this.state.user;
        user[name] = value;
        this.setState({ user });
    }

    handleChangeCpf = value => {
        let user = this.state.user;
        user.cpf = formatCpf(value);
        this.setState({ user});
    }

    handleSubmit = event => {
        event.preventDefault();
        let user = this.state.user;
        user.cpf = clearDigitsSpecialChars(this.state.user.cpf);
        Api.saveUsuario(user)
        .then(response => openSnackbar({ message: "Usuário salvo com sucesso" }))
        .catch(error => openSnackbar({ message: "Erro ao salvar usuário" }));
    }

}



// WEBPACK FOOTER //
// ./src/views/profile/Profile.js